import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { useEffect, useState } from 'react';
import { ProductDetails } from '../types/mapped';
import { useProductService } from './serviceHooks';

interface UseProductDetailsArgs {
    productRecordId: number | undefined;
    context: ICoreContext;
    location: string;
}

export const useProductDetails = ({ productRecordId, context, location }: UseProductDetailsArgs) => {
    const productService = useProductService(context.request, context.telemetry);
    const [productDetails, setProductDetails] = useState<ProductDetails>();
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        let ignore = false;

        setProductDetails(undefined);
        setHasError(false);

        if (productRecordId === undefined) {
            setIsLoading(false);
            return;
        }

        const fetchProductDetails = async () => {
            setIsLoading(true);
            const data = await productService.getProductDetails(String(productRecordId));
            if (!ignore) {
                if (data === undefined) {
                    const message = `[${location}] Error fetching product details for product ${productRecordId}`;
                    context.telemetry.error(message);
                    console.error(message);
                }

                setHasError(data === undefined);
                setProductDetails(data);
                setIsLoading(false);
            }
        };
        fetchProductDetails();

        return () => {
            ignore = true;
        };
    }, [productRecordId, productService, context.telemetry, location]);

    return { productDetails, isLoading, hasError };
};
